import React from 'react';
interface ITextProps {
    value: string
}
const TextTranslated = (props: ITextProps) => {
    return (
        <>
            {props.value}
        </>
    );
};

export default TextTranslated;